import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

//  产品预约申请
export async function rqtPostListAppointmentApplyPage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/apply/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtPostCountAppointmentApplyPage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/apply/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 预约保存，包括排队保存
export function rqtPostAppointmentSave(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/?UUID_KEY=${params.uuid_key}&sign=${params.sign}`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 打开预约详情
export async function rqtGetAppointment(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/detail`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtGetAppointmentDetail(appointmentId) {
  return request(
    `${BASE_URL}/provider/wms/appointment/${appointmentId}`,
    METHOD.GET
  )
}
//  产品预约排队查询，需要请求的接口
export async function rqtPostListAppointmentQueuePage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/queue/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtPostCountAppointmentQueuePage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/queue/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
//  产品预约记录查询，需要请求的接口
export async function rqtPostListAppointmentPage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtPostCountAppointmentPage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtPostSumAppointmentPage(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/sum`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 锁定预约
export async function rqtPutLockAppointment(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/lock`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// export async function rqtPutLockAppointment(id) {
//   return request(`${BASE_URL}/provider/wms/appointment/lock/${id}`, METHOD.PUT)
// }
// 撤销预约
export async function rqtPutCancleAppointment(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/cancle`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 撤销排队
export async function rqtPutCancleAppointmentQueue(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/cancle/queue`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 分配额度
export async function rqtPutDistributeAppointmentQueue(queueId) {
  return request(
    `${BASE_URL}/provider/wms/appointment/distribute/${queueId}`,
    METHOD.PUT
  )
}

//  数据导出，需要请求的接口
export async function rqtPostExportAppointment(params) {
  return request(
    `${BASE_URL}/provider/wms/appointment/export`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { responseType: 'blob' }
  )
}


